module.exports = __webpack_public_path__ + "media/images/front/centres/office_casablanca-50b7f6c290d96e414d3d83775a6747ba.jpg";